import * as React from "react";
const SvgFiRrFirst = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21 3.766V21a1 1 0 1 1-2 0V4.347l-2.283 2.351a.999.999 0 1 1-1.434-1.394l2.695-2.774a1.77 1.77 0 0 1 1.933-.393A1.76 1.76 0 0 1 21 3.767M11 11v3h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1H6v1a1 1 0 1 1-2 0v-1H3a1 1 0 1 1 0-2h1v-3H3a1 1 0 1 1 0-2h1V8a1 1 0 1 1 2 0v1h3V8a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2zm-2 0H6v3h3z"
    />
  </svg>
);
export default SvgFiRrFirst;
